import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationService } from '../../services/navigation.service';
import { LayoutService } from '../../services/layout.service';
import { MatIconModule } from '@angular/material/icon';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { NavigationItem } from './navigation-item/navigation-item';

@Component({
  selector: 'app-navigation',
  imports: [
    CommonModule,
    NavigationItem,
    MatIconModule,
    MatBottomSheetModule,
  ],
  templateUrl: './navigation.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Navigation {
  private navigationService = inject(NavigationService);
  private layoutService = inject(LayoutService);
  private bottomSheet = inject(MatBottomSheet);

  items = toSignal(this.navigationService.bottomNavItems$, { initialValue: [] });
  visible = this.layoutService.showBottomNav;

  async onNavAction(action: string): Promise<void> {
    if (action === 'open-quick-access') {
      const { QuickAccessPanel } = await import('../quick-access-panel/quick-access-panel');
      this.bottomSheet.open(QuickAccessPanel, {
        panelClass: 'quick-access-sheet',
      });
    }
  }
}
